app.service('overpaymentReturnModal', function (modal, validate, simpleToastr, loading, ajaxErrorHandler) {

	let subscriptionRefundId = null;
	let subscriptionProductType = null;
	let $self;

	function loadOverpaymentReturnForm({id, type}) {
		loading.start();
		subscriptionRefundId = id;
		subscriptionProductType = type;

		$.ajax({
			url: "/overpayment-return.ltr",
			type: "GET",
			data: {subscriptionRefundId: id},
			success(overpaymentReturnHtml) {
				openModal(overpaymentReturnHtml);
			},
			error(xhr, textStatus, errorThrown) {
				ajaxErrorHandler.createFailHandler('subscriptionOverpayment.loadOverpaymentReturnForm')(xhr, textStatus, errorThrown);
			},
			complete() {
				loading.stop();
			}
		});
	}

	function submitOverpaymentReturnForm($form) {
		loading.start();

		$.ajax({
			url: "/overpayment-return.ltr?recurringPaymentId=" + subscriptionRefundId + "&subscriptionProductType=" + subscriptionProductType,
			type: "POST",
			data: $form.serialize(),
			success: function (html) {
				loading.stop();
				$self.html(html);

				if($self.find('.success').length) {
					modal.close();
					loading.reload();
				} else if($self.find('.error-mpc').length) {
					const errorContent = $self.find('.error-mpc').html();
					modal.close();
					simpleToastr.generate(errorContent, {modifier: 'modifier-warning'});
				} else {
					loading.stop();
					validateForm();
				}
			},
			error() {
				loading.stop();
				modal.close();
				modal.alert('Błąd pobierania danych. Spróbuj ponownie później');
			},
		});
	}

	function openModal(overpaymentReturnHtml) {
		modal.generate({
			id: 'overpayment-modal',
			content: '<div id="overpayment-modal-form">' + overpaymentReturnHtml + '</div>',
			callbackOpen: function() {
				$self = $('#overpayment-modal-form');
				validateForm();
			}
		});
	}

	function validateForm () {
		validate.task('overpaymentReturn', function(form) {
			submitOverpaymentReturnForm($(form));
		});
	}

	return {
		load: loadOverpaymentReturnForm,
	};
});
